

















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { PolicyRisks } from '@/common/Policy.d';

import { mapGetters } from 'vuex';
import filter from 'lodash/filter';

import { captureException as sentryCaptureException } from '@sentry/browser';

// Components
import Alert from '@/components/Global/Alert.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import PolicySelector from '@/components/Global/PolicySelector.vue';

// Services
import Policy from '@/services/Policy';

@Component({
	name: 'PageCOI',
	components: {
		Alert,
		Welcome,
		PolicySelector,
		Loading,
	},
})
export default class UmiaPolicy extends Vue {
	@Getter('thirtyDayPolicies', { namespace: 'Policy' }) private policies: any;
	private policy_number: string = '';
	private loading: boolean = true;
	private selectedPolicy: boolean = false;
	private error: boolean = false;
	private policy: any = false;

	@Watch('$route', { deep: true })
	private watchRoute(newValue) {
		this.policy_number = this.$route.params.policy_number;

		if (this.policy_number) {
			this.setPolicy(this.policy_number);
		}
	}

	get limits() {
		const limits = filter(this.policy.coi.type_of_coverage, {
			type: 'Professional Liability',
		});

		const excessLimits = filter(this.policy.coi.type_of_coverage, {
			type: 'Professional Liability Excess',
		});
		return excessLimits ? excessLimits : limits;
	}

	get risks() {
		return Object.values(this.policy.risks)
			.map((risk: PolicyRisks) => {
				try {
					if (risk.insured === undefined) {
						return undefined;
					}
					const checkForNullRegex = /null|Ancillary|Physician/;

					if (risk.insured.org && !checkForNullRegex.test(risk.insured.org)) {
						risk.name = risk.insured.org;
					}

					if (risk.insured.name) {
						const splitRiskName = risk.insured.name.split(',');

						if (splitRiskName.length > 0) {
							const split1 = splitRiskName[0];
							const split2 = splitRiskName[1];

							if (split1 && !checkForNullRegex.test(split1)) {
								if (split2 && !checkForNullRegex.test(split2)) {
									risk.name = risk.insured.name;
								} else {
									risk.name = split1;
								}
							} else {
								return undefined;
							}
						}
					}

					// If both the insured name or org are true in the regex, remove the risk
					if (
						checkForNullRegex.test(risk.insured.org) &&
						checkForNullRegex.test(risk.insured.name)
					) {
						return undefined;
					}

					/**
					 * We want to remove any risks that our older than the policy_effective_end date
					 */
					const policyEffectiveEnd = new Date(risk.insured.policy_effective_end);
					const toDaysDate = new Date();

					if (!(policyEffectiveEnd >= toDaysDate)) {
						return undefined;
					}
				} catch (e) {
					console.log(e);
					sentryCaptureException(e);
				}

				return risk;
			})
			.filter(item => item !== undefined);
	}

	private changePolicyNum(e) {
		this.$router.push({
			name: 'coi',
			params: {
				policy_number: e,
			},
		});
	}

	private async setPolicy(policyIndex) {
		try {
			this.error = false;
			this.loading = true;
			const policy = this.policies.find(p => p.policy_number === policyIndex);
			// console.log(policy);
			this.selectedPolicy = policy;

			if (!!this.selectedPolicy) {
				this.policy = this.selectedPolicy;
			}

			if (this.policies.length === 1 && !this.selectedPolicy) {
				this.setPolicy(this.policies[0].policy_number);
			}

			if (!!this.policy && this.policy.message === undefined) {
				let mainRisk;

				if (this.policy.client_id) {
					mainRisk = this.policy.risks[this.policy.client_id];
				} else {
					const getMainRisk = Object.keys(this.policy.risks).filter(
						risk => this.policy.risks[risk].main_risk === 'Y',
					);
					mainRisk = this.policy.risks[getMainRisk[0]];
				}

				if (mainRisk) {
					this.policy.coi = mainRisk;
					this.loading = false;
				} else {
					this.loading = false;
					this.error = true;
					this.policy = false;
				}
			}
		} catch (e) {
			this.error = true;
			console.log(e);
			sentryCaptureException(e);
		}
	}

	private async created() {
		this.policy_number = this.$route.params.policy_number
			? this.$route.params.policy_number
			: '';

		if (this.policy_number !== '') {
			this.setPolicy(this.policy_number);
			this.loading = false;
		}

		if (!this.policy_number) {
			if (this.policies.length <= 0) {
				try {
					await Policy.setPolicyData();
				} finally {
					window.sidebarGetPolicyInfo = true;

					this.loading = false;
				}
			} else if (this.policies.length === 1) {
				this.setPolicy(0);
			} else {
				this.loading = false;
			}
		}
	}
}
